import React from 'react';

export interface TeamFormResult {
  matchId: string;
  matchDate: string;
  venue: string | null;
  isHome: boolean;
  opponent: {
    id: string;
    name: string;
    shortName: string | null;
    logoUrl: string | null;
  };
  teamGoals: number;
  opponentGoals: number;
  result: 'win' | 'loss' | 'draw';
}

export interface TeamForm {
  team: {
    id: string;
    name: string;
  };
  form: TeamFormResult[];
  summary: {
    wins: number;
    losses: number;
    draws: number;
    total: number;
  };
}

interface TeamFormIndicatorProps {
  teamId: string;
  teamForms: Record<string, TeamForm>;
}

const TeamFormIndicator: React.FC<TeamFormIndicatorProps> = ({ teamId, teamForms }) => {
  const form = teamForms[teamId];

  if (!form || form.form.length === 0) {
    return null;
  }

  return (
    <div className="flex justify-center gap-1 sm:gap-1.5 mt-2">
      {form.form.slice().reverse().map((result, index) => {
        let bgColor: string;
        let textColor: string;

        if (result.result === 'win') {
          bgColor = '#10b981';
          textColor = '#ffffff';
        } else if (result.result === 'loss') {
          bgColor = '#ef4444';
          textColor = '#ffffff';
        } else {
          bgColor = '#6b7280';
          textColor = '#ffffff';
        }

        return (
          <div
            key={`${result.matchId}-${index}`}
            className="flex items-center justify-center font-bold text-[10px] sm:text-xs w-[18px] h-[18px] sm:w-6 sm:h-6"
            style={{
              backgroundColor: bgColor,
              color: textColor,
              borderRadius: '4px',
            }}
          >
            {result.result === 'win' ? 'W' : result.result === 'loss' ? 'L' : 'D'}
          </div>
        );
      })}
    </div>
  );
};

export default TeamFormIndicator;
